export const defaultUserFileTypePrivilegies = {
    pending: [],
    admin: ['XLS', 'JSON', 'DXF', 'CSV', 'PDF'],
    salesvp: ['PDF', 'XLS'],
    salesmanager: ['PDF', 'XLS', 'DXF'],
    distributors: ['PDF', 'CSV', 'XLS', 'JSON'],
    distributorsmanager: ['PDF', 'XLS'],
    dealers: ['PDF', 'XLS', 'JSON']
};

export const defaultUserPagePrivilegies = ['SR', 'TR', 'SP'];


export const fontSizeMap = {
    'default': {
        '2.5': 7.5,
        '3.5': 9.4,
        '4.5': 12.6
    }, 
    'metal' : {
        '3.5': 12.6
    }
};
export const textBoxHeight = {
    '2.5': 9,
    '3.5': 12.34,
    '4.5': 15.11
};
export const iconSizeMap = {
    6: 'small',
    8: 'medium',
    10: 'big'
};
export const textSizeMap = {
    '2.5': 'small',
    '3.5': 'medium',
    '4.5': 'big'
};

export const iconSizeSmall = {
    label: 6,
    title: "Small"
};
export const iconSizeMedium = {
    label: 8,
    title: "Medium"
};
export const iconSizeBig = {
    label: 10,
    title: "Big"
};
export const textSizeSmall = {
    label: 2.5,
    title: "Small"
};
export const textSizeMedium = {
    label: 3.5,
    title: "Medium"
};
export const textSizeBig = {
    label: 4.5,
    title: "Big"
};

export const numberOfIconsPerLayout = (store) => {
    return {
        alba: {
            A: 2,
            B: 4,
            D: 4,
            M1: 2
        },
        blackjack: {
            A: 1,
            B: 2,
            C: 3,
            D: 4,
            M1: (store.getters.squareOrRectangle == 'rectangle') ? 2 : 3
        }
    }
};


export const productCode = {
    category: 'K',
    series: {
        aria: 'R',
        alba: 'L',
        axes: 'H',
        blackjack: 'J'
    },
    opt1: { //if layout is not in this object then it is used in product code as is
        aria: {
            'L9': '09',
            'L12': '12',
            'M1': 'M1',
            'SK': 'L2',
        },
        axes: {
            'CR': 'HS',
            'CH': 'HR',
            'DR': 'OR',
            'KN': 'NK',
            'N34': 'N3',
            'N35': 'N3',
            'SK': 'L2',
        },
        blackjack: {
            'SK': 'L2'
        },
        alba: {
            'SK': 'L2'
        }
    },
    opt2: {
        'single': '1F',
        'double': '2F',
        'vdouble': '2F',
        'triple': '3F',
        'vtriple': '3F'
    },
    opt3: {
        'Crestron': 'C',
        'KNX': 'K',
        'RS485': 'R'
    },
    opt4: function (color) {
        return color.substring(0, 1).toUpperCase();

    },
    opt5: function (artwork) {
        let code = '';

        if(artwork.frameColor.charAt(0) == 'm') {
            code = artwork.frameColor.charAt(1).toUpperCase();
            if (code == 'B') {
                code = 'S'; //Brass is S in product code
            }
        }
        
        if (typeof artwork.keyColor != 'undefined' && artwork.keyColor.charAt(0) != artwork.frameColor.charAt(0)) {
            if (artwork.keyColor.charAt(0) == 'm') {
                let code_add = artwork.keyColor.charAt(1).toUpperCase();
                if (code_add == 'B') {
                    code_add = 'S'; //Brass is S in product code
                }
                code += code_add;
            } else {
                code += artwork.keyColor.charAt(0).toUpperCase();
            }
        }
        
        return code;
    },
    opt6: {
        'square': 'S',
        'round': 'R',
        'oval': 'O',
        'rectangle': 'T'
    },
    prn: function (state, store) {
        if (state.artwork.format == 'single') return '';

        var LEFT = state.productCode?.opt1?.[state.artwork.type]?.[state.artwork.layout] || state.artwork.layout;
        var RIGHT = state.productCode?.opt1?.[state.artwork.type]?.[state.artwork.rightLayout] || state.artwork.rightLayout;
        var TRIPLE_RIGHT = (store.getters.isTriple) ? state.productCode?.opt1?.[state.artwork.type]?.[state.artwork.tripleRightLayout] || state.artwork.tripleRightLayout : '';

        return LEFT + RIGHT + TRIPLE_RIGHT;
    }
};
export const mapLayout = {
    BA: 'AB',
    CB: 'BC',
    DA: 'AD',
    DB: 'BD'
};

export const styleMap = {
    alba: {
        AA: {
            iconOnly: [1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5],
        },
        AB: {
            iconOnly: [1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5],
        },
        AD: {
            iconOnly: [1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5],
        },
        BB: {
            iconOnly: [1, 1, 1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5],
        },
        BD: {
            iconOnly: [1, 1, 1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5],
        },
        DD: {
            iconOnly: [1, 1, 1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5],
        },
        M1: {
            iconOnly: [1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5],
        },
        SK: {
            socket: []
        }
    },
    aria: {
        L9: {
            iconOnly: [1, 1, 1, 1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3, 3],
            iconSingleLineTextMid: [1, 2, 1, 1, 2, 1, 1, 2, 1],
            iconDoubleLineTextMid: [1, 3, 1, 1, 3, 1, 1, 3, 1],
            iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5, 5],
        },
        L12: {
            iconOnly: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
            iconSingleLineTextMid: [1, 2, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1],
            iconDoubleLineTextMid: [1, 3, 1, 1, 3, 1, 1, 3, 1, 1, 3, 1],
            iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
        },
        M1: {
            iconOnly: [1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5],
        },
        SK: {
            socket: []
        }
    },
    axes: {
        CR: {
            iconOnly: [1, 1, 1, 1, 1, 6, 6, 6],
            singleLineText: [2, 2, 2, 2, 2, 6, 6, 6],
            doubleLineText: [3, 3, 3, 3, 3, 6, 6, 6],
            iconSingleLineText: [4, 4, 4, 4, 4, 6, 6, 6],
            iconDoubleLineText: [5, 5, 5, 5, 5, 6, 6, 6],
        },
        CH: {
            iconOnly: [1, 1, 1, 1, 1, 6, 6, 6],
            singleLineText: [2, 2, 2, 2, 2, 6, 6, 6],
            doubleLineText: [3, 3, 3, 3, 3, 6, 6, 6],
            iconSingleLineText: [4, 4, 4, 4, 4, 6, 6, 6],
            iconDoubleLineText: [5, 5, 5, 5, 5, 6, 6, 6],
        },
        DR: {
            iconOnly: [6],
        },
        KN: {
            iconOnly: [7, 7, 7, 7, 7, 7, 7, 7, 7, 1, 7, 1],
            singleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 2, 7, 2],
            doubleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 3, 7, 3],
            iconSingleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 4, 7, 4],
            iconDoubleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 5, 7, 5],
        },
        N34: {
            iconOnly: [7, 7, 7, 7, 1, 1, 1],
            singleLineText: [7, 7, 7, 7, 2, 2, 2],
            doubleLineText: [7, 7, 7, 7, 3, 3, 3],
            iconSingleLineText: [7, 7, 7, 7, 4, 4, 4],
            iconDoubleLineText: [7, 7, 7, 7, 5, 5, 5],
        },
        N35: {
            iconOnly: [7, 7, 7, 7, 7, 1, 1, 1],
            singleLineText: [7, 7, 7, 7, 7, 2, 2, 2],
            doubleLineText: [7, 7, 7, 7, 7, 3, 3, 3],
            iconSingleLineText: [7, 7, 7, 7, 7, 4, 4, 4],
            iconDoubleLineText: [7, 7, 7, 7, 7, 5, 5, 5],
        },
        SK: {
            socket: []
        }
    },
    blackjack: {
        AA: {
            iconOnly: [1, 1],
            singleLineText: [2, 2],
            doubleLineText: [3, 3],
            iconSingleLineText: [4, 4],
            iconDoubleLineText: [5, 5],
        },
        AB: {
            iconOnly: [1, 1, 1],
            singleLineText: [2, 2, 2],
            doubleLineText: [3, 3, 3],
            iconSingleLineText: [4, 4, 4],
            iconDoubleLineText: [5, 5, 5],
        },
        BB: {
            iconOnly: [1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5],
        },
        BC: {
            iconOnly: [1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5],
        },
        CC: {
            iconOnly: [1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5],
        },
        DD: {
            iconOnly: [1, 1, 1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5],
        },
        M1: {
            iconOnly: [1, 1, 1, 1, 1, 1],
            singleLineText: [2, 2, 2, 2, 2, 2],
            doubleLineText: [3, 3, 3, 3, 3, 3],
            iconSingleLineText: [4, 4, 4, 4, 4, 4],
            iconDoubleLineText: [5, 5, 5, 5, 5, 5],
        },
        SK: {
            socket: []
        }
    }
};
export const defaultIconColors = {
    'gw': '#706f6e',
    'pw': '#706f6e',
    'sc': '#706f6e',
    'sg': '#706f6e',
    'gwm': '#706f6e',
};

export const userTypeMap = {
    'pending': 'Pending',
    'admin': 'Admin',
    'salesvp': 'Sales VP',
    'salesmanager': 'SalesManager',
    'distributors': 'Partner',
    'distributorsmanager': 'PartnerManager',
    'dealers': 'Dealers'
};
export const iconFontMap = {
    alba: {
        socket: {},
        iconOnly: {
            hasIconSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig]
        },
        singleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        doubleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        iconSingleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        iconDoubleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        iconSingleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        iconDoubleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        }
    },
    aria: {
        socket: {},
        iconOnly: {
            hasIconSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig]
        },
        singleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        doubleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        iconSingleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconDoubleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconSingleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconDoubleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium],
            fontSize: [textSizeSmall, textSizeMedium]
        }
    },
    axes: {
        socket: {},
        iconOnly: {
            hasIconSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig]
        },
        singleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        doubleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
        },
        iconSingleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconDoubleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconSingleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconDoubleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium],
            fontSize: [textSizeSmall, textSizeMedium]
        }
    },
    blackjack: {
        socket: {},
        iconOnly: {
            hasIconSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium]
        },
        singleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium]
        },
        doubleLineText: {
            hasFontSize: true,
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconSingleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconDoubleLineTextMid: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeMedium, iconSizeBig],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconSingleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium],
            fontSize: [textSizeSmall, textSizeMedium]
        },
        iconDoubleLineText: {
            hasIconSize: true,
            hasFontSize: true,
            iconSize: [iconSizeSmall, iconSizeMedium],
            fontSize: [textSizeSmall, textSizeMedium]
        }
    }
};

export const defaultIcons = {
    N34: {
        4: 'icon-d6',
        5: 'icon-a4',
        6: 'icon-c6'
    },
    N35: {
        5: 'icon-d6',
        6: 'icon-a4',
        7: 'icon-c6'
    },
    CR: {
        0: 'icon-d6',
        1: 'icon-c6',
        2: 'icon-h3',
        3: 'emptyslot',
        4: 'emptyslot'
    },
    CH: {
        0: 'icon-d6',
        1: 'icon-c6',
        2: 'icon-h3',
        3: 'emptyslot',
        4: 'emptyslot'
    },
    KN: {
        9: 'icon-A-10-13',
        11: 'icon-A-11-16'
    }
};

export function buildContentArray(state, layoutKey, layoutStyleKey, store) {
    const layout = state.artwork[layoutKey];
    const layoutStyle = state.artwork[layoutStyleKey];
    if (!layout || !layoutStyle) return;
    const style = state.styleMap[state.artwork.type][layout][layoutStyle].slice();
    
    if (state.artwork.type == 'blackjack' && layout === 'M1' && store.getters.squareOrRectangle == 'rectangle' && style.length == 6) {
        style.splice(0, 2);
    }
    const content = [];
    let mainIcon = 'icon-a';

    if (store.getters.isFullMetal) {
        mainIcon = 'icon-C-01-01';
    }

    for (let i = 0; i < style.length; i++) {
        let singleContent;

        switch (style[i]) {
            case 1:
                singleContent = {
                    hasIcon: true,
                    icon: defaultIcons[layout]?.[i] || mainIcon,
                    type: 'normal'
                };
                break;
            case 2:
                singleContent = {
                    hasTextL1: true,
                    textL1: 'textl1',
                    type: 'normal'
                };
                break;
            case 3:
                singleContent = {
                    hasTextL1: true,
                    hasTextL2: true,
                    textL1: 'textl1',
                    textL2: 'textl2',
                    type: 'normal'
                };
                break;
            case 4:
                singleContent = {
                    hasIcon: true,
                    hasTextL1: true,
                    icon: mainIcon,
                    textL1: 'textl1',
                    type: 'normal'
                };
                break;
            case 5:
                singleContent = {
                    hasIcon: true,
                    hasTextL1: true,
                    hasTextL2: true,
                    icon: mainIcon,
                    textL1: 'textl1',
                    textL2: 'textl2',
                    type: 'normal'
                };
                break;
            case 6:
                if (layout === 'CH' || layout === 'CR') {
                    singleContent = {
                        hasIcon: true,
                        icon: i === 5 ? "icon-A-05-04" : "icon-circle",
                        iconSize: i === 5 ? 14.7 : 7.8,
                        disabled: true,
                        type: 'backlight'
                    };
                } else if (layout === 'DR') {
                    singleContent = {
                        hasIcon: true,
                        icon: "icon-c4",
                        iconSize: 12.4,
                        disabled: true,
                        type: 'backlight'
                    };
                }
                break;
            case 7:
                if (layout === 'KN') {
                    let text = i + 1 === 11 ? 0 : i + 1;
                    singleContent = {
                        hasTextL1: true,
                        textL1: text.toString(),
                        fontSize: 22,
                        disabled: true,
                        isNumber: true,
                        type: 'backlight'
                    };
                } else if (layout === 'N34') {
                    singleContent = {
                        hasTextL1: true,
                        textL1: "0",
                        fontSize: 110,
                        isNumber: true,
                        type: 'backlight'
                    };
                } else if (layout === 'N35') {
                    singleContent = {
                        hasTextL1: true,
                        textL1: "0",
                        fontSize: 90,
                        isNumber: true,
                        type: 'backlight'
                    };
                }
                break;
        }

        // Set color
        if (singleContent) {
            const colorKey = ['aria', 'axes'].includes(state.artwork.type)
                ? state.artwork.frameColor
                : state.artwork.keyColor;
            singleContent.color = store.getters.getDefaultIconColor(colorKey);
            content.push(singleContent);
        }
    }

    if (state.artwork.type == 'aria' && state.artwork[layoutKey] == 'M1' && state.artwork[layoutKey + 'AriaM1TempIcons']) {
        //add temperature control icons
        content.push(
            { type: 'backlight', iconSize: 6, color: '#ffffff', icon: 'icon-f6', hasIcon: true, hasTextL1: false, hasTextL2: false, isNumber: false, disabled: true },
            { type: 'backlight', iconSize: 6, color: '#ffffff', icon: 'icon-g7', hasIcon: true, hasTextL1: false, hasTextL2: false, isNumber: false, disabled: true },
        );

    }

    return content;
}